import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Lightbox from './Lightbox';
const useStyles = makeStyles({
    thumb: {
        width: '100%',
        overflow: 'hidden',
        borderRadius: 4,
        cursor: 'pointer',
        objectFit: 'cover',
        background: '#ccc',
    }
});
export function LightboxThumbnail(props) {
    var _a, _b;
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const classes = useStyles();
    return React.createElement("div", { style: { height: props.height || 'unset' } },
        ((_a = props.images) === null || _a === void 0 ? void 0 : _a.length) &&
            React.createElement("img", { src: props.images[0].urls.thumbnail, height: props.height, loading: "lazy", className: classes.thumb, onClick: (_b = props.onImageClick) !== null && _b !== void 0 ? _b : (() => setLightboxOpen(true)) }) || null,
        lightboxOpen &&
            React.createElement(Lightbox, { images: props.images, open: true, onClose: () => setLightboxOpen(false) }) || null);
}
